import React from 'react';
import styles from './PastDeliveryOtpCard.module.less';
import { Typography } from 'antd';
import { useTranslation, withTranslation } from 'react-i18next';
import * as PropTypes from 'prop-types';
import { formatDate } from '../../utils/dates';
import Paper from '../Paper/Paper';

const PastDeliveryOtpCard = props => {
  const { t } = useTranslation();
  const { otp, createdAt, bookingId, dateFormat } = props;
  return (
    <Paper data-testid="PastDeliveryOtpCard">
      <div className={styles.header}>
        <Typography.Text strong>
          {t('deliveryOtps.token')} #{otp}
        </Typography.Text>
        <span>
          {`${t('deliveryOtps.bookingId')} #`}
          <span>{bookingId}</span>
        </span>
      </div>
      <div className={styles.createdAt}>
        <span>{formatDate(createdAt, dateFormat)}</span>
      </div>
    </Paper>
  );
};

PastDeliveryOtpCard.propTypes = {
  otp: PropTypes.string.isRequired,
  createdAt: PropTypes.instanceOf(Date).isRequired,
  bookingId: PropTypes.number,
  dateFormat: PropTypes.string
};

PastDeliveryOtpCard.defaultProps = {
  dateFormat: 'd MMM yyyy, p'
};

export default withTranslation()(PastDeliveryOtpCard);
